import CoreExtension from '@/core/CoreExtension'

export default CoreExtension.extend({
    props: {
        startCollapsed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
        }
    },
    watch: {
        startCollapsed: {
            immediate: true,
            handler(val) {
                this.visible = !val
            }
        }
    }
})